/* import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { compactNumber } from "../../screens/dashboard/DashboardCard";

const BarChatDesktop = ({ label, online, inStore, currency }) => {
  console.log(label, online, inStore, "bar chart data");

  const isMobile = window.innerWidth <= 568;

  const yValue = [...online, ...inStore].map((val) => Number(val) || 0);
  const maxY = Math.max(0, ...yValue);
  const stepSize = maxY === 0 ? 10 : Math.ceil(maxY / 50);

  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 16,
        },
        display: false,
      },
      title: {
        display: false,
        text: "Amount of Product Sold",
      },
      tooltip: {
        callbacks: {
          // show full value in tooltip (not compact)
          label: (ctx) => `${ctx.dataset.label.trim()}: ${compactNumber(ctx.parsed.y)}`,
        },
      },
    },
    scales: {
      y: {
        ticks: {
          // compact labels on the axis
          callback: (value) => compactNumber(value),
          stepSize: stepSize,
        },
        title: {
          display: isMobile ? false : true,
          text: "Sales in " + "(" + currency + ")",
        },
        grid: {
          display: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    barThickness: 4,
    borderRadius: 8,
  };

  const labels = label.slice(0, -1);

  const data = {
    labels,
    datasets: [
      {
        label: "online sales",
        data: online.slice(0, -1),
        borderColor: "#5887DE",
        backgroundColor: "#5887DE",
      },
      {
        label: "in-store sales",
        data: inStore.slice(0, -1),
        borderColor: "#a4cc47",
        backgroundColor: "#a4cc47",
      },
    ],
  };

  return (
    <>
      <Bar height={200} width={180} data={data} options={options} />
    </>
  );
};

export default BarChatDesktop;
 */

import { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

/*
  BarChatDesktop
  ──────────────
  Props:
    label    — string[]  x-axis labels
    online   — number[]  online sales per period
    inStore  — number[]  in-store sales per period
    currency — string
*/
export default function BarChatDesktop({ label = [], online = [], inStore = [], currency = "₦" }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  const fmtVal = (v) => {
    if (v >= 1e6) return currency + (v / 1e6).toFixed(1) + "M";
    if (v >= 1e3) return currency + (v / 1e3).toFixed(0) + "K";
    return currency + v.toLocaleString();
  };

  useEffect(() => {
    if (!canvasRef.current) return;
    if (chartRef.current) chartRef.current.destroy();

    chartRef.current = new Chart(canvasRef.current, {
      type: "bar",
      data: {
        labels: label,
        datasets: [
          {
            label: "In-store",
            data: inStore,
            backgroundColor: "#a4cc47",
            borderRadius: 3,
            borderSkipped: false,
          },
          {
            label: "Online",
            data: online,
            backgroundColor: "#4A90E2",
            borderRadius: 3,
            borderSkipped: false,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => ` ${ctx.dataset.label}: ${fmtVal(ctx.raw)}`,
            },
          },
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              color: "rgba(0,0,0,0.35)",
              font: { size: 9 },
              maxRotation: 45,
              autoSkip: true,
              maxTicksLimit: 7,
            },
          },
          y: {
            grid: { color: "rgba(0,0,0,0.05)" },
            ticks: { color: "rgba(0,0,0,0.35)", font: { size: 10 }, callback: fmtVal },
            beginAtZero: true,
          },
        },
      },
    });

    return () => {
      if (chartRef.current) chartRef.current.destroy();
    };
  }, [label, online, inStore, currency]);

  return (
    <div style={{ position: "relative", width: "100%", height: 160 }}>
      <canvas ref={canvasRef} role='img' aria-label='Total sales bar chart by channel' />
    </div>
  );
}
